<template>
  <AppHeader />

  <RouterView />

  <AppFooter />
</template>

<script lang="ts" setup>
import { onBeforeMount } from 'vue'

import { setApiToken } from '@/api'
import AppFooter from '@/components/widgets/AppFooter.vue'
import AppHeader from '@/components/widgets/AppHeader.vue'
import { useAuthStore } from '@/store/bowler-app/auth'
import { usePreferencesStore } from '@/store/preferences'

const preferences = usePreferencesStore()

onBeforeMount((): void => {
  setApiToken(useAuthStore().accessToken)
  preferences.setLocale(preferences.locale)
})
</script>

<style lang="scss"></style>
